import actionTypes from './index';

export default sharedEstimates =>
  ({ type: actionTypes.SHARE_ESTIMATE_SUCCESS, payload: { ...sharedEstimates } });
